import { render, staticRenderFns } from "./UpdateV2.vue?vue&type=template&id=49972c26&scoped=true"
import script from "./UpdateV2.vue?vue&type=script&lang=js"
export * from "./UpdateV2.vue?vue&type=script&lang=js"
import style0 from "./UpdateV2.vue?vue&type=style&index=0&id=49972c26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49972c26",
  null
  
)

export default component.exports